import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TipoFirmante, TipoFirmanteCopiaBasica, TipoFirmanteNifEmitter } from '../../../envios/models/tipo-firmante';
import { DatosEnviosService } from '../../../envios/services/datos-envios.service';
import { FirmanteNif } from '../../models/firmante-nif';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-configuracion-documento-configurar-nif',
  templateUrl: './configuracion-documento-configurar-nif.component.html',
  styleUrls: ['./configuracion-documento-configurar-nif.component.css']
})
export class ConfiguracionDocumentoConfigurarNifComponent implements OnInit {

  tiposFirmantes: TipoFirmanteCopiaBasica[] = []; //TipoFirmante[];
  @Input() idPdf: string;
  @Output() cargaNifEmitter:EventEmitter<boolean> = new EventEmitter<boolean>();
  tiposFirmatesApi: TipoFirmanteCopiaBasica[] = [];

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              private datosEnvioService: DatosEnviosService,
              private _snackBar: MatSnackBar,
              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService) {
                this.getTipoFirmantes();
              }

  ngOnInit(): void {
  }

  get generico(){ return this.formularioDocumentoService.formularioDocumento.controls['generico'] }

  get esCopiaBasica(){ return this.formularioDocumentoService.formularioDocumento.controls['esCopiaBasica'] }

  get firmantesNif(){ return this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'] as FormArray}

  getTipoFirmantes(forceReload = false){
    if (!forceReload && this.datosConfiguracionDocumentosService.hasTiposFirmanteCatalogo()) {
      this.aplicarTiposFirmantes(this.datosConfiguracionDocumentosService.getTiposFirmanteCatalogo() as TipoFirmanteCopiaBasica[]);
      return;
    }

    this.datosEnvioService.getTipoFirmante().subscribe(
      next => {
        this.datosConfiguracionDocumentosService.setTiposFirmanteCatalogo(next);
        this.aplicarTiposFirmantes(next);
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  private aplicarTiposFirmantes(next: TipoFirmanteCopiaBasica[]): void {
    this.tiposFirmatesApi = next;
    this.reordenarFirmantes();
    this.datosConfiguracionDocumentosService.noExistenNifs = [];
    this.tiposFirmantes.forEach(x=>{
      this.datosConfiguracionDocumentosService.noExistenNifs.push(false)
      x.checkSiCopiaBasica = false;
    })
    if(this.esCopiaBasica.value){
      this.tiposFirmantes.forEach(x=>{
        if(x.codigo=='100') x.checkSiCopiaBasica = true;
        else x.checkSiCopiaBasica = false;
      })
    }
  }

  cargandoNifs: TipoFirmanteNifEmitter[] = [];

  isNifCargando(event:TipoFirmanteNifEmitter){
    let indexFirmante = this.cargandoNifs.findIndex(x => x.firmante==event.firmante);
    if(indexFirmante > -1){
      this.cargandoNifs[indexFirmante] = event;
    }else{
      this.cargandoNifs.push(event)
    }
    let arrayNifBoolean: boolean[] = [];
    this.cargandoNifs.forEach(x=> arrayNifBoolean.push(x.cargando))
    if(arrayNifBoolean.includes(true)) this.cargaNifEmitter.emit(true);
    else this.cargaNifEmitter.emit(false)
  }

  anadirFirmante(event:number){
    let firmanteParaAnadir = this.tiposFirmatesApi.find(x=> Number(x.codigo)==event &&
    !this.tiposFirmantes.includes(x));

    if(firmanteParaAnadir) this.tiposFirmantes.push(firmanteParaAnadir)
  }

  reordenarFirmantes(){
    //buscamos el firmante con el código más alto para incluir hasta uno más en la lista, por defecto se incluirá hasta el firmante con código 103 (Firmante adicional 1).
    const maxCodigo = Math.max(...this.firmantesNif.value.map((x:FirmanteNif) => Number(x.tipoFirmante.codigo)));
    if(maxCodigo>102) this.tiposFirmantes = this.tiposFirmatesApi.filter(x=>Number(x.codigo)<=(maxCodigo+1));
    else this.tiposFirmantes = this.tiposFirmatesApi.filter(x=>Number(x.codigo)<104);
  }

  trackByCodigo(_index: number, tipo: TipoFirmanteCopiaBasica): string {
    return tipo.codigo ?? String(_index);
  }
}
